import { renderReact } from "@/react/main";
import { renderVue } from "@/vue/main";
import { REACT_APP_ID } from "@/react/routing/constants";

renderReact(document.getElementById(REACT_APP_ID));
renderVue(document.getElementById("vue-app"));
